module.exports = __webpack_public_path__ + "static/img/SG.643dd22.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/countryFlag/SG.svg
// module id = UbaJ
// module chunks = 66